/**
 * Reusable stateless form component for Contact Us
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import form components
import {
  EmailInput
  , TextAreaInput
  , TextInput
} from '../../../global/components/forms';
function ContactUsForm({
  handleCancel
  , contactUs
  , errors
  , formTitle
  , handleFormChange
  , handleFormSubmit
  , successMessage
}) {

  // set the button text
  const buttonText = "Contact Support";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="contactUsForm" className="contact-us-form" onSubmit={handleFormSubmit}>
            {header}
            <p className="u-centerText"><strong>Contact Pro-ficiency with your questions and we will get back to you shortly!</strong></p>
            { errors ?
                <p className="u-centerText" style={{color:"red"}}><strong>Error:</strong> {errors}</p>
              :
                null
            }
            { successMessage ?
                <p className="u-centerText" style={{color:"green"}}><strong>Success:</strong> {successMessage}</p>
              :
                null
            }
            <EmailInput
              change={handleFormChange}
              disabled={true}
              label="Email Address"
              name="email"
              placeholder="Email Address"
              required={true}
              value={contactUs.email}
            />
            <TextInput
              change={handleFormChange}
              label="Name"
              name="name"
              placeholder="Name"
              required={true}
              value={contactUs.name}
            />
            <TextInput
              change={handleFormChange}
              label="Subject"
              name="subject"
              placeholder="Subject"
              required={true}
              value={contactUs.subject}
            />
            <TextAreaInput
              cols={100}
              change={handleFormChange}
              label="Message"
              name="message"
              placeholder="Message goes here..."
              required={true}
              rows={"5"}
              value={contactUs.message}
            />
            <div className="input-group">
              <div className="yt-row space-between">
                <button className="yt-btn link" type='button' onClick={handleCancel}>Cancel</button>
                <button className="yt-btn" type="submit"> {buttonText} </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

ContactUsForm.propTypes = {
  handleCancel: PropTypes.func.isRequired
  , contactUs: PropTypes.object.isRequired
  , errors: PropTypes.string
  , formTitle: PropTypes.string
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , successMessage: PropTypes.string
}

ContactUsForm.defaultProps = {
  formTitle: ''
}

export default ContactUsForm;



// WEBPACK FOOTER //
// modules/static/components/ContactUsForm.js.jsx